import {applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {TextBoxProperties, TextBox as TextBoxDisplayObject} from '@gongxigames/framework/core/fragments/display';

export const TextBox = PixiComponent<TextBoxProperties, TextBoxDisplayObject>('TextBox', {
    create(props: TextBoxProperties): TextBoxDisplayObject {
        return new TextBoxDisplayObject(props);
    },
    applyProps(instance: TextBoxDisplayObject, oldProps: TextBoxProperties, newProps: TextBoxProperties): void {
        applyDefaultProps(instance, oldProps, newProps);
    }
});
